import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './ui/table';
import { Badge } from './ui/badge';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { ExternalLink } from 'lucide-react';
import { toast } from 'sonner';
import { getAuthenticatedAxios, handleAuthError } from '../utils/api';

const WarmupHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [walletFilter, setWalletFilter] = useState('');
  const [limit, setLimit] = useState(100);

  useEffect(() => {
    fetchHistory();
  }, [walletFilter, limit]);

  const fetchHistory = async () => {
    try {
      const api = getAuthenticatedAxios();
      const params = { limit };
      if (walletFilter) {
        params.wallet_address = walletFilter;
      }
      const response = await api.get('/api/warmup/history', { params });
      if (response.data.success) {
        setHistory(response.data.history);
      }
    } catch (error) {
      console.error('Error fetching history:', error);
      handleAuthError(error, toast);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const variants = {
      'SUCCESS': 'default',
      'FAILED': 'destructive',
      'PENDING': 'secondary',
      'SKIPPED': 'outline',
    };
    return <Badge variant={variants[status] || 'outline'}>{status}</Badge>;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Warmup History</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex gap-4 mb-4">
          <Input
            placeholder="Filter by wallet address..."
            value={walletFilter}
            onChange={(e) => setWalletFilter(e.target.value)}
            className="max-w-sm"
          />
          <Input
            type="number"
            placeholder="Limit"
            value={limit}
            onChange={(e) => setLimit(parseInt(e.target.value))}
            className="max-w-24"
          />
        </div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Timestamp</TableHead>
              <TableHead>Wallet</TableHead>
              <TableHead>Token</TableHead>
              <TableHead>Buy Status</TableHead>
              <TableHead>Sell Status</TableHead>
              <TableHead>Spent (TON)</TableHead>
              <TableHead>Received (TON)</TableHead>
              <TableHead>P&L (TON)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {history.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{new Date(item.timestamp).toLocaleString()}</TableCell>
                <TableCell className="font-mono text-xs">
                  <div className="flex items-center gap-2">
                    <span>{item.wallet_address.slice(0, 10)}...</span>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="h-6 w-6 p-0"
                      onClick={() => {
                        window.open(`https://tonviewer.com/${item.wallet_address}`, '_blank');
                      }}
                      title="Просмотреть кошелек в Tonviewer"
                    >
                      <ExternalLink className="h-3 w-3" />
                    </Button>
                  </div>
                </TableCell>
                <TableCell>{item.token_symbol}</TableCell>
                <TableCell>{getStatusBadge(item.buy_status)}</TableCell>
                <TableCell>{getStatusBadge(item.sell_status)}</TableCell>
                <TableCell>{item.total_spent_ton?.toFixed(4) || '0'}</TableCell>
                <TableCell>{item.total_received_ton?.toFixed(4) || '0'}</TableCell>
                <TableCell>
                  <span className={item.profit_loss_ton >= 0 ? 'text-green-600' : 'text-red-600'}>
                    {item.profit_loss_ton?.toFixed(4) || '0'}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default WarmupHistory;

